<ng-template #addressChangeReviewModal let-modal>
  <div class="modal-header justify-content-between">
    <div>
      <h4 class="modal-title d-inline-block fw-bold">Address Change Request</h4>
      <br />
      <small class="ms-2"
        ><span *ngIf="!isEmployeePortal">{{ changeRequest.RequesterName }} - </span
        ><span class="fw-bold">Date Requested: </span
        >{{ changeRequest.DateRequested | date: 'MM/dd/YY' }}</small
      >
    </div>
    <div>
      <span *ngIf="changeRequest.Approved" class="badge bg-connectpay">Approved</span>
      <span *ngIf="!changeRequest.Approved && !changeRequest.Pending" class="badge bg-danger"
        >Declined</span
      >
      <span *ngIf="changeRequest.Pending" class="badge bg-warning">Pending</span>
      <button type="button" class="close ms-3" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-6 text-center">
        <span class="fw-bold">Old Address</span>
      </div>
      <div class="col-6 text-center">
        <span class="fw-bold">New Address</span>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <span>{{ addressChangeRequestData.Old?.StreetAddress }}</span
        ><br />
        <span
          *ngIf="
            addressChangeRequestData.Old?.StreetAddress2 != null &&
            addressChangeRequestData.Old.StreetAddress2 != ''
          "
          >{{ addressChangeRequestData.Old?.StreetAddress2 }}</span
        ><br
          *ngIf="
            addressChangeRequestData.Old.StreetAddress2 != null &&
            addressChangeRequestData.Old.StreetAddress2 != ''
          " />
        <span
          >{{ addressChangeRequestData.Old?.City }}, {{ addressChangeRequestData.Old?.State }}
          {{ addressChangeRequestData.Old?.PostalCode }}</span
        >
        <ng-container *ngIf="addressChangeRequestData.Old?.Country != null">
          <br /><span>{{ addressChangeRequestData.Old.Country }}</span>
        </ng-container>
      </div>
      <div class="col-6">
        <span>{{ addressChangeRequestData.New?.StreetAddress }}</span> <br />
        <span
          *ngIf="
            addressChangeRequestData.New.StreetAddress2 != null &&
            addressChangeRequestData.New.StreetAddress2 != ''
          "
          >{{ addressChangeRequestData.New.StreetAddress2 }}</span
        ><br
          *ngIf="
            addressChangeRequestData.New.StreetAddress2 != null &&
            addressChangeRequestData.New.StreetAddress2 != ''
          " />
        <span
          >{{ addressChangeRequestData.New.City }}, {{ addressChangeRequestData.New.State }}
          {{ addressChangeRequestData.New.PostalCode }}</span
        >
        <ng-container *ngIf="addressChangeRequestData.New?.Country != null">
          <br /><span>{{ addressChangeRequestData.New.Country }}</span>
        </ng-container>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <label>Comment:</label>
        <textarea
          class="form-control"
          [disabled]="true"
          [(ngModel)]="addressChangeRequestData.Comment"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer text-right">
    <button
      class="btn btn-secondary"
      (click)="cancelAddressRequest()"
      *ngIf="changeRequest.Pending">
      Cancel Change
    </button>
    <button class="btn btn-primary ms-3" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>
